import {globalUser} from "./globals.js";
import {getGameActiveCompanies, getGameMainUserCompany, getUserControlledCompanies} from "./games.js";
import {
    addCompanyCompanyAlerts,
    addCompanyEvents,
    addCompanyMessages,
    addCompanyNewsItems,
    getCompanyChampionships,
    getCompanyCompanyAlerts,
    getCompanyCompanyLogs,
    getCompanyDraft,
    getCompanyEvents,
    getCompanyFacilities,
    getCompanyFeudItems,
    getCompanyGame,
    getCompanyReceivedNegotiations,
    getCompanySegmentItems,
    getCompanySentNegotiations,
    getCompanyStaff, getCompanyStoryChoices,
    getCompanyTournaments,
    removeCompanyChampionships,
    removeCompanyEvents,
    removeCompanySegmentItems
} from "../models/company.js";
import {
    addNewCompetitorCheck,
    changeProperty,
    checkCompetitorsAvailableForBuyout,
    checkFacilityUpgrade,
    checkObjectHot,
    checkObjectStale,
    createCompanyAlert, generateFormNewCompanyOwnerName,
    getActiveCompetitorsForCompany,
    getAvailableStaffMembers,
    getAvailableStaffMembersByRole,
    getBuyoutSuperstars,
    getCompanyLatestEvent, getCompanyMonth,
    getCompanyParentEvents,
    getCompanyRosterByType,
    getCompanyRosterCapacity, getCompanyYear,
    getCpuControlledCompanies,
    getCurrentMonth,
    getHighestLevelStaffMemberByRole,
    getRandomStaffMemberByRole,
    getStaffAgeMultiplier,
    getTutorialStateName,
    processChampionshipXpChange,
    processObjectiveCompleted,
    removeStaffTaskData,
    updateObjectOverness,
    updateStaffMemberXp
} from "./companies.js";
import {
    addRosterFeuds,
    addRosterStaff,
    addRosterSuperstars,
    addRosterTagTeams,
    getRosterBrands,
    getRosterFeuds,
    getRosterStaff,
    getRosterSuperstars,
    getRosterTagTeams
} from "../models/roster.js";
import {
    calculateEventRating,
    getEventMatchesAndSegments,
    getLatestMonthlyEvent,
    getNextEvent,
    getParentEventForEvent,
    getSuperstarsUsedAtEvent
} from "./events.js";
import {
    getMonthsDifference,
    getMoraleText,
    getOvernessText,
    getRandomChoice,
    getRandomInt,
    limitValueBetweenRange,
    myround,
    objectInArray,
    weightedChoice,
    toTitleCase, captureError, gameLimits, eventPrestigeXps
} from "./helpers.js";
import {
    addFutureSuperstar,
    addNextGimmickBoost,
    checkAvailability,
    checkObjectBrandAvailability,
    checkSuperstarBrandAvailability,
    endSuperstarInjury,
    evaluateInjury,
    getFutureSuperstarsToAdd,
    getInjuryReturnTime,
    getRankFromPopularity,
    processSuperstarContract,
    processSuperstarMorale,
    processSuperstarTemporaryInjury,
    processSuperstarTemporaryTrophy,
    recoverSuperstarFatigue,
    removeSuperstarFactionRelationships,
    removeSuperstarManagerRelationships,
    updateSuperstarMorale,
    updateSuperstarPopularity,
    vacateChampionships
} from "./superstars.js";
import {getAllSuperstarsForMatch, getMatchChampionships, getMatchEvent, getMatchParticipants} from "../models/match.js";
import {getEventMatchContracts, getEventMatches, getParentEvent} from "../models/event.js";
import {
    createAvailableSuperstarMessage,
    createBuyoutAcceptedMessage,
    createBuyoutAcceptedTrainerMessage,
    createBuyoutNotAvailableSuperstarMessage,
    createBuyoutSigningsMessage,
    createChampionshipNotUsedPenaltyMessage,
    createEndFeudReminderMessage,
    createFeudEndedMessage, createFormingNewCompanyPotentialMessage,
    createFutureSuperstarMessage,
    createGimmickChangeBoostMessage,
    createIndieSuperstarAvailableMessage,
    createInjuryReevaluatedMessage,
    createInjuryRehabMessage,
    createMessage,
    createNewIndieSuperstarMessage,
    createNewIndieSuperstarRecruitedMessage,
    createSpecialSegmentReuseMessage,
    createStaffMemberRetirementChanceMessage,
    createStaffMemberRetirementMessage,
    createTrainingRosterHotMessage,
    createTrainingRosterPopularityMessage,
    createTrainingRosterStaleMessage,
    createWorkableInjuryRecoveryMessage,
    generateRamblingMessage
} from "./messages.js";
import {addFeudSuperstars, Feud, getFeudParticipants} from "../models/feud.js";
import {getFeudRating, getRosterMemberFeuds} from "./feuds.js";
import {getBrandForEvent, getBrandIndexForWeeklyShow} from "./brands.js";
import {processFactionXpChangeForSuperstar} from "./factions.js";
import {checkTalentRequestAction, checkTalentRequestCreation, processTalentRequests} from "./talentRequests.js";
import {removeTagTeam} from "./tagTeams.js";
import {checkAreChampionshipsEqual, getUniqueChampionships} from "./championships.js";
import {checkCharacterToUnlock, updateSuperstarWorkrate} from "./processMatch.js";
import {generateNewsItem} from "./news.js";
import {checkProducerSegmentItemsToUnlock, updateSuperstarCharisma} from "./segments.js";
import {
    getSuperstarCurrentGimmick,
    getSuperstarOriginalRoster,
    getSuperstarRandomEvents,
    getSuperstarRelationships,
    getSuperstarTagTeams,
    removeSuperstarChampionships,
    removeSuperstarRandomEvents
} from "../models/superstar.js";
import {getChampionshipDisplayName, getChampionshipsDisplayName} from "../ui/ui-helpers.js";
import {getTagTeamSuperstars} from "../models/tagTeam.js";
import {transferTalentToRoster, turnRosterMember} from "./rosters.js";
import {
    Championships,
    CompanyAlerts, Events,
    Feuds,
    MatchContracts,
    Negotiations,
    Relationships
} from "../models/models.js";
import {getChampionshipCurrentReign, getChampionshipSuperstar} from "../models/championship.js";
import {getMatchContractChampionship, getMatchContractTalent} from "../models/matchContract.js";
import {addFeudItemFeuds} from "../models/feudItem.js";
import {getNegotiationSenderCompany, getNegotiationTalent} from "../models/negotiation.js";
import {setGameCurrentCompany} from "../models/game.js";
import {getChampionshipReignMatches} from "../models/championshipReign.js";
import {filterOffersSentToCpuCompanies, processNegotiation} from "./negotiations.js";
import {
    buildInterest,
    getRehabChance,
    getTalentRehabDoctor,
    makeTrainingTalentAvailable,
    reassureTalent,
    recruitTalent,
    scoutTalent,
    trainTalent,
    transitionStaffMemberToSuperstar,
    transitionSuperstarToStaffMember,
    transitionTalent,
    unlearnTalentTrait
} from "./staff.js";
import {processAnnualTournament} from "./annualTournament.js";
import {checkYearlyDraft} from "./draft.js";
import {generateStaffMember, generateSuperstar} from "./generate.js";
import {traitsData} from "../data/traits.js";
import {loadUser, saveUser} from "./user.js";
import {checkForStaffRandomEvent, randomEventCheck} from "./randomEvents.js";
import {getPowPostEventDialogs, processPowStoryChoices} from "./passionOfWrestling.js";

async function endEvent(company, user, simulation = false, rosterSuperstars = null, userSimulatorOption = 'manage',
                        eventsToSimulate = null) {  // end_event
    // Declare variables
    const data = {
        leftCompany: [],
        vacated: [],
        tradeReturns: [],
        notUsedAtEvent: [],
        hotChanges: [],
        staleChanges: [],
        staffSkillIncreases: [],
        rehabbed: [],
        staffActionsCompleted: [],
        unlockedCharacters: [],
        availableSuperstars: [],
        signings: [],
        offersAccepted: [],
        moraleChanges: [],
        notUsedMoraleDecreases: [],
        factionReputationsData: [],
        notUsedPopularityDecreases: [],
        fotcChanges: [],
        matchContractsNotUsed: []
    };

    // Get objects
    const game = await getCompanyGame(company);
    const mainCompany = await getGameMainUserCompany(game);
    const latestEvent = await getCompanyLatestEvent(company);
    const parentEvents = await getCompanyParentEvents(company);
    let staffMembers = await getCompanyStaff(company);
    const companyChampionships = await getCompanyChampionships(company);
    const mainRoster = await getCompanyRosterByType(company, 'main');
    const indieRoster = await getCompanyRosterByType(mainCompany, 'indie');
    const indieAvailableRoster = await getCompanyRosterByType(mainCompany, 'indieAvailable');
    const trainingRoster = await getCompanyRosterByType(company, 'training');
    const trainingAvailableRoster = await getCompanyRosterByType(company, 'trainingAvailable');
    const parentEvent = await getParentEventForEvent(parentEvents, latestEvent);
    const indieSuperstars = await getRosterSuperstars(indieRoster);
    const indieAvailableSuperstars = await getRosterSuperstars(indieAvailableRoster);
    const allTrainingSuperstars = (await getRosterSuperstars(trainingRoster)).concat(await getRosterSuperstars(trainingAvailableRoster));
    const scoutingFacility = (await getCompanyFacilities(company)).find(facility => facility.name === 'Scouting');
    const talentManager = getRandomStaffMemberByRole(staffMembers, 'talent_manager');
    const weeklyShow = latestEvent.weeklyShow || latestEvent.name === 'Weekly Show' || latestEvent.temporaryEvent;
    const companySegmentItems = await getCompanySegmentItems(company);
    const eventMatchesAndSegments = (await getEventMatchesAndSegments(latestEvent)).reverse();

    const rosterBrands = await getRosterBrands(mainRoster);
    const isMainCompany = mainCompany.$loki === company.$loki;
    const month = game.monthCount;
    const year = game.year;
    const companyMonth = getCompanyMonth(company, game);
    const companyYear = getCompanyYear(company, game);
    const startingFans = company.fans;
    if (!rosterSuperstars) {
        rosterSuperstars = await getRosterSuperstars(mainRoster);
    }
    const superstarsUsedAtEvent = await getSuperstarsUsedAtEvent(eventMatchesAndSegments, rosterSuperstars);

    // Check for annual tournament todo test and test usages
    const annualTournament = (await getCompanyTournaments(mainCompany)).find(x => x.annualTournament && x.status !== 'ended');
    const annualTournamentRunning = annualTournament && annualTournament.status === 'running';  // True for night 1 & 2

    // Lower prestige of championships not defended recently
    if (globalUser.paid) {
        if (!weeklyShow) {
            const championshipsNotUsedRecently = [];
            const xpChange = -5;
            const uniqueChampionships = getUniqueChampionships(companyChampionships
                .filter(x => !x.championshipContract && !x.matchContract &&
                    checkObjectBrandAvailability(x, latestEvent.brandName, false, latestEvent.activeEffect)));

            for (const championship of uniqueChampionships) {
                // Get months passed since last used
                const monthsPassed = await getMonthsPassedSinceChampionshipMatch(championship, companyChampionships,
                    company, month, year, companyMonth, companyYear);

                // Lower xp if more than 6 months passed
                if (monthsPassed > 6) {
                    await processChampionshipXpChange(championship, xpChange, companyChampionships);
                    championshipsNotUsedRecently.push(championship);
                }

                // Message if 6 months passed
                if (company.userControlled && monthsPassed === 6) {
                    // Add message
                    const newMessage = await createChampionshipNotUsedPenaltyMessage(championship, month, year, talentManager);
                    await addCompanyMessages(company, [newMessage]);
                }
            }

            // Add to return data
            if (championshipsNotUsedRecently.length > 0) {
                data['championshipsNotUsedRecently'] = getChampionshipsDisplayName(championshipsNotUsedRecently);
                data['championshipNotUsedXpChange'] = xpChange;
            }
        }
    }

    // Get rating
    let rating = calculateEventRating(eventMatchesAndSegments);
    // Ensure rating active effects work
    // Add buffer for first year since ratings are lower
    let high, low;
    if (game.year === 0) {
        high = 3.75;
        low = 3.25;
    } else {
        high = 4;
        low = 3.25;
    }
    if (latestEvent.activeEffect === 'lower_match_ratings') {
        if (rating >= low) {
            rating = low - 0.25;
        }
    } else if (latestEvent.activeEffect === 'raise_match_ratings') {
        if (rating <= high) {
            rating = high + 0.5;
        }
    }

    // Add points
    let pointsToAdd = getPointsToAdd(rating, weeklyShow);
    if (annualTournamentRunning) {
        pointsToAdd = 0;
    }
    if (pointsToAdd) {
        company.points += pointsToAdd;
    }

    // Add fans
    let [fansToAdd, hypeMultiplier] = getFansToAdd(rating, company.reputation, latestEvent.hype, weeklyShow);
    if (annualTournamentRunning) {
        fansToAdd = 0;
    }
    if (fansToAdd && game.marketSize === null) {
        company.fans += fansToAdd
    }

    // Add current month
    const eventNames = parentEvents.map(x => x.name);
    if (latestEvent.monthlyEventName && eventNames.includes(latestEvent.monthlyEventName)) {
        latestEvent.month = eventNames.indexOf(latestEvent.monthlyEventName);
        if (latestEvent.weekNumber < 0) {
            latestEvent.month -= 1;
            if (latestEvent.month < 0) {
                latestEvent.month = 11;
            }
        }
    } else {
        const companyEvents = await getCompanyEvents(company);
        const latestMonthlyEvent = getLatestMonthlyEvent(companyEvents);
        if (!eventNames.includes(latestMonthlyEvent.name)) {
            // If event name changed, use parent event name
            latestEvent.month = eventNames.indexOf((await getParentEvent(latestMonthlyEvent))?.name);
        } else {
            latestEvent.month = eventNames.indexOf(latestMonthlyEvent.name);
        }
    }

    // Add data to event
    latestEvent.rating = rating;
    latestEvent.pointsEarned = pointsToAdd;
    if (latestEvent.year === null) {
        latestEvent.year = company.realYear; // For compatibility with older games
    }
    if (game.marketSize === null) {
        latestEvent.fansGained = fansToAdd;
    }

    // Change company overness
    if (!annualTournamentRunning) {
        const startingOverness = company.overness;
        const overnessChange = getCompanyOvernessChange(rating, company);
        updateObjectOverness(company, overnessChange);
        checkObjectHot(company, overnessChange);
        const staleCheck = checkObjectStale(company, overnessChange);

        // Add overness change data
        const startingOvernessText = getOvernessText(startingOverness, false);
        const endingOvernessText = getOvernessText(company.overness, false);
        if (endingOvernessText !== startingOvernessText) {
            data['companyOvernessChange'] = {
                name: company.name,
                previousOverness: startingOvernessText,
                currentOverness: endingOvernessText,
                overness: company.overness,
                increase: company.overness > startingOverness
            };
        }

        // Add news if company got stale
        if (staleCheck === 'stale') {
            let newsItem = await generateNewsItem({company: company, month: game.newsMonth, year: game.newsYear,
                newsType: 'stale_company'});
            await addCompanyNewsItems(mainCompany, [newsItem]);
        }

        // Change brand overness
        const eventBrand = getBrandForEvent(latestEvent, rosterBrands);
        if (eventBrand) {
            const startingOverness = eventBrand.overness;
            const brandOvernessChange = getBrandOvernessChange(rating, eventBrand);
            updateObjectOverness(eventBrand, brandOvernessChange);
            checkObjectHot(eventBrand, brandOvernessChange);
            checkObjectStale(eventBrand, brandOvernessChange);

            // Add overness change data
            const startingOvernessText = getOvernessText(startingOverness, false);
            const endingOvernessText = getOvernessText(eventBrand.overness, false);
            if (endingOvernessText !== startingOvernessText) {
                data['brandOvernessChange'] = {
                    name: eventBrand.name,
                    color: eventBrand.color,
                    previousOverness: startingOvernessText,
                    currentOverness: endingOvernessText,
                    overness: eventBrand.overness,
                    increase: eventBrand.overness > startingOverness
                };
            }
        }
    }

    // Mars story events todo later

    // Check if new year started
    let newYearStarted = false;
    if (!weeklyShow && game.newsMonth + 1 > 11) {
        newYearStarted = true;
    }

    // Update month, year and yearly checks for user company
    if (!weeklyShow) {
        if (company.userControlled) {
            // In multiplayer, increases game's month, resets later in this function. Fixes month and year for messages, random events, etc
            game.monthCount += 1;
            if (game.monthCount > 11) {
                game.monthCount = 0;
                game.year += 1;
                if (!company.newUserCompany) {
                    company.yearlyCheckRun = false;
                    company.yearlyReviewRun = false;
                }
            }
        }

        // New user company's month is separate as it can be out of sync with game, is used for callup etc
        if (company.newUserCompany) {
            company.month += 1;
            if (company.month > 11) {
                company.month = 0;
                company.year += 1;
                company.yearlyCheckRun = false;
                company.yearlyReviewRun = false;
            }
        }
    }

    // Check for reputation increase or decrease
    const fanLevels = [0, 500, 1100, 2300, 5000, 10500, 22000, 47000, 99000, 212000, 451000, 1000000];
    let fansToNextReputation = fanLevels[company.reputation];
    let fansToPreviousReputation = fanLevels[company.reputation - 1];
    let reputationIncrease = false;
    let reputationDecrease = false;
    if (!annualTournamentRunning) {
        if (game.marketSize === null) {
            // Reputation increase
            if (company.fans >= fansToNextReputation && company.reputation < 10) {
                company.reputation += 1;
                reputationIncrease = true;

                // Reset fan levels
                fansToNextReputation = fanLevels[company.reputation];
                fansToPreviousReputation = fanLevels[company.reputation - 1];

                // Show benefits of reputation increase only once, using highestReputation to check
                if (company.reputation > company.highestReputation) {
                    company.highestReputation = company.reputation;

                    // Unlock story powerups for specific reputation increases todo
                    if (isMainCompany && company.storyName === 'mars') {

                    }
                }

                data['rosterSize'] = getCompanyRosterCapacity(company, game);
            // Reputation decrease
            } else if (company.fans < fansToPreviousReputation && company.reputation > 1) {
                company.reputation -= 1;
                reputationDecrease = true;

                // Reset fan levels
                fansToNextReputation = fanLevels[company.reputation];
                fansToPreviousReputation = fanLevels[company.reputation - 1];

                data['rosterSize'] = getCompanyRosterCapacity(company, game);
            }
        }
    }

    // Get next event if not tournament weekly show
    let nextEvent;
    if (latestEvent.name === 'Weekly Show' || latestEvent.temporaryEvent) {
        await removeCompanyEvents(company, [latestEvent]);
    } else {
        nextEvent = await getNextEvent(latestEvent, parentEvents, company, game.numberOfWeeklyShows);
        await addCompanyEvents(company, [nextEvent]);
    }

    // Update event prestige if paid version
    let eventPrestigeData = null;
    if (!weeklyShow && globalUser.paid) {
        // Update event's xp
        let xpChange;
        if (latestEvent.rating < 3.5) {
            xpChange = (4 - latestEvent.rating) * -10;
        } else if (latestEvent.rating < 5) {
            xpChange = (3 - latestEvent.rating) * -15;
        } else {
            xpChange = (2.5 - latestEvent.rating) * -15;
        }
        xpChange = Math.floor(xpChange);
        parentEvent.xp += xpChange;

        // Update event's prestige
        let prestigeIncrease = false;
        let prestigeDecrease = false;

        if (parentEvent.xp >= 110 && parentEvent.prestige !== 'A') {
            parentEvent.prestige = 'A';
            prestigeIncrease = true;
        } else if (40 <= parentEvent.xp && parentEvent.xp < 110 && parentEvent.prestige !== 'B') {
            if (parentEvent.prestige === 'A') {
                prestigeDecrease = true;
            } else {
                prestigeIncrease = true;
            }
            parentEvent.prestige = 'B';
        } else if (parentEvent.xp < 40 && parentEvent.prestige !== 'C') {
            parentEvent.prestige = 'C';
            prestigeDecrease = true;
        }

        // Add prestige data
        const prestige = parentEvent.prestige;
        const prestigeMaximums = {'A': 10, 'B': 9, 'C': 8};
        eventPrestigeData = {
            name: latestEvent.name,
            prestige: prestige,
            xp: parentEvent.xp,
            xpChange: xpChange,
            baseXp: eventPrestigeXps[prestige],
            xpToNextPrestige: prestige === 'C' ? 40 : 110,
            prestigeIncrease: prestigeIncrease,
            prestigeDecrease: prestigeDecrease,
            matchLimit: prestigeMaximums[prestige] || 8,
        };
    }

    // Monthly checks
    if (!weeklyShow) {
        // Check for training callup
        if (companyMonth === 11 || companyMonth === 5) {
            company.trainingTransferRun = false;
            company.trainingCallupRun = false;
        }

        if (isMainCompany) {
            // Check for awards
            if (month === 9) {
                game.awardsRun = false;
            }
            // Check for yearly rankings in January
            if (latestEvent.month === 11) {
                game.yearlyAttributesResetRan = false;
            }
        }
    }

    if (isMainCompany) {
        // Reset monthly simulation
        game.monthlySimulationRun = false;
    }

    // Decrease overness and morale for active superstars not used
    if (!weeklyShow) {
        for (const s of rosterSuperstars) {
            if (!objectInArray(s, superstarsUsedAtEvent) && s.injured <= 0 && s.suspensionMonths <= 0
                && !s.partTimer && !s.retired && !s.dead && !s.unavailable
                && !s.fullTimeManager && checkSuperstarBrandAvailability(latestEvent, s)) {

                const startingOverness = s.overness;
                const overnessDecrease = getRandomInt(0, 1);
                s.overness -= overnessDecrease;
                const overnessChange = s.overness - startingOverness;

                // Make sure overness is percentage between 0 and 100
                s.overness = limitValueBetweenRange(s.overness, 0, 100);

                // Add overness change data
                const startingOvernessText = getOvernessText(startingOverness);
                const endingOvernessText = getOvernessText(s.overness);
                if (endingOvernessText !== startingOvernessText) {
                    data['notUsedAtEvent'].push({
                        name: s.name,
                        previousOverness: startingOvernessText,
                        currentOverness: endingOvernessText,
                        overness: s.overness,
                        increase: s.overness > startingOverness
                    });
                }

                // Check hot
                const hotCheck = checkObjectHot(s, overnessChange);
                if (hotCheck) {
                    data['hotChanges'].push({name: s.name, pronoun: s.possessivePronoun, status: hotCheck});

                    // Check for character unlock upon hot
                    if (globalUser.paid && hotCheck === 'hot') {
                        const superstarGimmick = await getSuperstarCurrentGimmick(s);
                        if (superstarGimmick) {
                            if (superstarGimmick.character) {
                                const unlockedCharacter = checkCharacterToUnlock(superstarGimmick.character);
                                if (unlockedCharacter) {
                                    data['unlockedCharacters'].push({name: unlockedCharacter,
                                        originalCharacter: superstarGimmick.character});
                                }
                            }
                        }
                    }

                    if (hotCheck === 'hot') {
                        // Add news
                        let newsItem = await generateNewsItem({
                            company: company, month: game.newsMonth, year: game.newsYear, superstar: s, newsType: 'over_superstar',
                        });
                        await addCompanyNewsItems(mainCompany, [newsItem]);

                        // Check goal
                        if (company.userControlled) {
                            let objectiveCompleted = await changeProperty({
                                name: 'get over', change: 1, company: company, superstarName: s.name
                            });
                            if (objectiveCompleted) {
                                await processObjectiveCompleted(objectiveCompleted, company);
                            }
                        }
                    }
                }

                // Check stale
                let staleCheck = checkObjectStale(s, overnessChange);
                if (staleCheck) {
                    data['staleChanges'].push({name: s.name, pronoun: s.possessivePronoun, status: staleCheck});

                    if (staleCheck === 'stale') {
                        // Add news
                        let newsItem = await generateNewsItem({
                            company: company, month: game.newsMonth, year: game.newsYear, superstar: s, newsType: 'stale_superstar'
                        });
                        await addCompanyNewsItems(mainCompany, [newsItem]);

                        // Update faction rep (overness change)
                        const superstarFactionsData = await processFactionXpChangeForSuperstar({superstar: s, overnessChange: 'stale'});
                        data['factionReputationsData'].push(...superstarFactionsData);
                    }
                }

                // Decrease morale for main eventers if not high fatigue
                if (getRankFromPopularity(s.popularity) === 'Main Eventer' && s.fatigue < 50) {
                    let moraleDecrease = 2;
                    updateSuperstarMorale(s, moraleDecrease * -1);
                    data['notUsedMoraleDecreases'].push({name: s.name, decrease: moraleDecrease});
                    let startingMorale = s.morale + moraleDecrease;
                    let startingMoraleText = getMoraleText(startingMorale);
                    let endingMoraleText = getMoraleText(s.morale);
                    if (endingMoraleText !== startingMoraleText) {
                        data['moraleChanges'].push({
                            name: s.name,
                            previousMorale: startingMoraleText,
                            currentMorale: endingMoraleText,
                            morale: s.morale
                        });
                    }
                }
            }
        }

        // Decrease popularity for active main eventers not used at event
        for (const s of rosterSuperstars) {
            if (!objectInArray(s, superstarsUsedAtEvent) && getRankFromPopularity(s.popularity) === 'Main Eventer' &&
                checkAvailability(s, false, false, false) && checkSuperstarBrandAvailability(latestEvent, s)) {

                // Get popularity decrease
                let popularityDecrease = getNotUsedPopularityDecrease(s);
                s.popularity -= popularityDecrease;

                data['notUsedPopularityDecreases'].push({'name': s.name, 'decrease': popularityDecrease});

                // Remove FotC
                if (s.faceOfTheCompany && s.popularity < 1000) {
                    s.faceOfTheCompany = false;
                    s.faceOfTheCompanyCounter = 0;
                    data['fotcChanges'].push({name: s.name, faceOfTheCompany: s.faceOfTheCompany});

                    // Update faction rep (fotc)
                    const superstarFactionsData = await processFactionXpChangeForSuperstar({superstar: s, fotcChange: 'lostFotc'});
                    data['factionReputationsData'].push(...superstarFactionsData);
                }
            }
        }

        // Check talent request
        for (const s of superstarsUsedAtEvent) {
            await checkTalentRequestAction({company: company, requestType: 'be_on_monthly_event', talent: s});
        }
    }

    // Manage contracts
    if (!weeklyShow) {
        let leftCompanySuperstars = [];
        for (const superstar of rosterSuperstars) {
            if (superstar.activeEffect !== 'traded') {
                const leftCompany = await processSuperstarContract(superstar, company, game);
                if (leftCompany) {
                    leftCompanySuperstars.push(superstar);
                    data['leftCompany'].push(superstar.name);
                }
            }
        }

        // Update rosterSuperstars
        rosterSuperstars = rosterSuperstars.filter(x => !objectInArray(x, leftCompanySuperstars));
    }

    if (!weeklyShow) {
        let superstarsReturned = [];
        if (!(company.userControlled && game.settings['control_multiple_companies'])) {

            // Move/remove teams if trade ending
            const onTradeSuperstars = rosterSuperstars.filter(x => x.activeEffect === 'traded');
            for (const superstar of onTradeSuperstars) {
                if (superstar.appearances === 1) {
                    for (const tagTeam of [...(await getSuperstarTagTeams(superstar))]) {
                        let ts = await getTagTeamSuperstars(tagTeam);
                        // Move team if all members were on trade together
                        if (ts.every(s => objectInArray(s, onTradeSuperstars) && s.appearances === 1)) {
                            await addRosterTagTeams((await getSuperstarOriginalRoster(superstar)), [tagTeam]);
                        }
                        // Otherwise, remove team
                        else {
                            await removeTagTeam(tagTeam);
                        }
                    }
                }
            }

            // Process superstars on trade
            for (const superstar of onTradeSuperstars) {
                superstar.appearances -= 1;
                if (superstar.appearances <= 0) {
                    const originalRoster = await getSuperstarOriginalRoster(superstar);
                    if (originalRoster) {
                        await addRosterSuperstars(originalRoster, [superstar]);
                        superstarsReturned.push(superstar);

                        const vacatedChampionships = await vacateChampionships({
                            superstar: superstar, championships: companyChampionships, month, year
                        });
                        if (vacatedChampionships.length > 0) {
                            data['vacated'].push(...vacatedChampionships);
                        }

                        // Remove from factions/managers
                        await removeSuperstarFactionRelationships(superstar, month, year);
                        await removeSuperstarManagerRelationships(superstar);

                        // Reset other attributes
                        superstar.brandName = null;
                        superstar.activeEffect = null;
                        if (!superstar.partTimer) {
                            superstar.appearances = null;
                        }
                        data['tradeReturns'].push(superstar.name);
                    }
                }
            }
        }

        // Update rosterSuperstars
        rosterSuperstars = rosterSuperstars.filter(x => !objectInArray(x, superstarsReturned));

        // Add alignment months
        for (const superstar of rosterSuperstars) {
            if (!superstar.retired) {
                superstar.alignmentMonths += 1;
            }
        }

        // Update injured superstars
        let doctors = getAvailableStaffMembersByRole(staffMembers, 'doctor');
        let injuredData = await updateInjured(rosterSuperstars, doctors, company);
        data['staffSkillIncreases'].push(...injuredData['staffSkillIncreases']);
        data['rehabbed'] = injuredData['rehabbed'];

        for (const availableData of injuredData['available']) {
            let s = availableData['superstar'];

            // Add news if not recovering from superstarBreak random event
            let superstarBreakRandomEvent = (await getSuperstarRandomEvents(s)).reverse()
                .find(x => x.name === 'superstarBreak');
            if (!superstarBreakRandomEvent) {
                let newsType = availableData['workableInjury'] ? 'workable_injury_return' : 'injury_return';
                let newsItem = await generateNewsItem({
                    company: company, month: game.newsMonth, year: game.newsYear, superstar: s, newsType: newsType
                });
                await addCompanyNewsItems(mainCompany, [newsItem]);
            } else {
                // Remove superstarBreak random event for future injuries to show
                await removeSuperstarRandomEvents(s, [superstarBreakRandomEvent]);
            }

            // Increase overness if not superstar break or workable injury
            let overnessIncrease = null;
            if (!superstarBreakRandomEvent && !availableData['workableInjury']) {
                overnessIncrease = getRandomInt(4, 6);
                s.overness += overnessIncrease;

                const addedNextGimmickBoost = await addNextGimmickBoost(s, 50);
                if (addedNextGimmickBoost && company.userControlled) {
                    let newMessage = await createGimmickChangeBoostMessage(s, 'Injury Return', month, year, talentManager);
                    await addCompanyMessages(company, [newMessage]);
                }
            }

            data['availableSuperstars'].push({name: s.name});

            if (company.userControlled) {
                let doctor = null;
                let assignedDoctor = getTalentRehabDoctor(s, doctors);
                if (assignedDoctor) {
                    doctor = assignedDoctor;
                } else if (doctors.length) {
                    doctor = getRandomStaffMemberByRole(doctors, 'doctor');
                }

                let newMessage;
                if (availableData['workableInjury']) {
                    newMessage = await createWorkableInjuryRecoveryMessage(s, month, year, doctor);
                } else {
                    newMessage = await createAvailableSuperstarMessage(s, overnessIncrease, month, year, doctor);
                }
                await addCompanyMessages(company, [newMessage]);

                // Add alert
                let alertType = availableData['workableInjury'] ? 'workableInjuryRecovered' : 'injuryRecovered';
                let newCompanyAlert = await createCompanyAlert(alertType, s.name);
                await addCompanyCompanyAlerts(company, [newCompanyAlert]);
            }
        }

        // Update suspended superstars
        for (const superstar of rosterSuperstars) {
            if (superstar.suspensionMonths > 0) {
                superstar.suspensionMonths -= 1;
            }
        }
    }

    // New competitors check, available for buyout check
    if (isMainCompany) {
        if (company.storyName !== 'mars' && !weeklyShow) {
            // Check if any competitors are available for buyout
            await checkCompetitorsAvailableForBuyout(company, month, year);

            // Check for new competitors
            if (game.settings['generate_competitors'] !== false) {
                data['newCompetitors'] = await addNewCompetitorCheck(company);
            }
        }
    }

    // Update indie and training superstars
    if (!weeklyShow) {
        // Check training future superstars
        let trainingFutureRoster = await getCompanyRosterByType(company, 'trainingFuture');
        if (trainingFutureRoster) {
            let toAdd = await getFutureSuperstarsToAdd(trainingFutureRoster, month, year);
            for (const x of toAdd) {
                if (company.userControlled) {
                    // Add to training roster for user
                    await addFutureSuperstar(x, trainingRoster);
                } else {
                    // Chance to send to main roster for competitors
                    // They can't choose callups and pick out the best ones
                    let sendToMainRosterChance = 40;
                    if (x.popularity >= 500) {
                        sendToMainRosterChance += 20;
                    }
                    if (x.popularity >= 800) {
                        sendToMainRosterChance += 40;
                    }
                    if (getRandomInt(0, 100) <= sendToMainRosterChance) {
                        await addFutureSuperstar(x, mainRoster);
                    } else {
                        await addFutureSuperstar(x, trainingRoster);
                    }
                }

                if (company.userControlled) {
                    // Add message
                    let newMessage = await createFutureSuperstarMessage(x, month, year, staffMembers, company, 'Training');
                    await addCompanyMessages(company, [newMessage]);
                }
            }
        }

        // Update training superstar attributes
        let trainer = getRandomStaffMemberByRole(staffMembers, 'trainer');
        let trainingFacility = (await getCompanyFacilities(company)).find(x => x.name === 'Training');
        let trainingFacilityLevel = trainingFacility ? trainingFacility.level : 1;
        let maxPopDict = {1: 800, 2: 850, 3: 900};
        let maxPop = maxPopDict[trainingFacilityLevel] || 900;
        let maxOvernessDict = {1: 80, 2: 85, 3: 90};
        let maxOverness = maxOvernessDict[trainingFacilityLevel] || 90;

        let changesDict = {
            normal: {
                1: {pop: [-4, 8], xp: [2, 4], overness: [-1, 2]},
                2: {pop: [-2, 12], xp: [3, 5], overness: [-1, 3]},
                3: {pop: [-1, 16], xp: [4, 6], overness: [-1, 4]}
            },
            inTraining: {
                1: {pop: [0, 12], xp: [2, 4], overness: [-1, 3]},
                2: {pop: [3, 15], xp: [3, 5], overness: [0, 4]},
                3: {pop: [6, 18], xp: [4, 6], overness: [1, 5]}
            }
        };

        let maxPopularityGainedSuperstars = [];
        for (const superstar of allTrainingSuperstars) {
            // Change popularity/overness/xp for active training superstars
            if (checkAvailability(superstar, true)) {
                // Get changes data
                let changesData = superstar.activeEffect === 'in_training' ?
                    changesDict['inTraining'][trainingFacilityLevel] : changesDict['normal'][trainingFacilityLevel];

                let popFloor = changesData['pop'][0];
                let popCeiling = changesData['pop'][1];
                let xpFloor = changesData['xp'][0];
                let xpCeiling = changesData['xp'][1];
                let overnessFloor = changesData['overness'][0];
                let overnessCeiling = changesData['overness'][1];

                // Popularity and xp
                let change = getRandomInt(popFloor, popCeiling);
                if (superstar.popularity + change < maxPop) {
                    superstar.popularity += change;
                    if (change === popCeiling) {
                        maxPopularityGainedSuperstars.push(superstar.name);
                    }
                } else {
                    // Change if close to max value
                    superstar.popularity += getRandomInt(-5, 0);
                }

                // Check for skill xp multiplier trait
                let traitMultiplier = 1;
                for (const trait of superstar.traits) {
                    let traitData = traitsData[trait];
                    if (traitData && traitData['skill_xp_multiplier']) {
                        traitMultiplier = traitData['skill_xp_multiplier'];
                    }
                }

                // Update xp
                let xpGain = Math.floor(getRandomInt(xpFloor, xpCeiling) * traitMultiplier);
                superstar.workrateXp += xpGain;
                await updateSuperstarWorkrate(superstar, company, staffMembers, month, year);
                xpGain = Math.floor(getRandomInt(xpFloor, xpCeiling) * traitMultiplier);
                superstar.charismaXp += xpGain;
                await updateSuperstarCharisma(superstar, company, staffMembers, month, year);

                // Overness
                let overnessChange = getRandomInt(overnessFloor, overnessCeiling);

                // Get trait multiplier for overness change
                for (const trait of superstar.traits) {
                    let traitData = traitsData[trait];
                    if (traitData && traitData['overness_increase_multiplier']) {
                        if (overnessChange > 0) {
                            overnessChange *= traitData['overness_increase_multiplier'];
                        }
                    }
                    if (traitData && traitData['overness_decrease_multiplier']) {
                        if (overnessChange < 0) {
                            overnessChange *= traitData['overness_decrease_multiplier'];
                        }
                    }
                }

                // Change overness
                if (superstar.overness + overnessChange < maxOverness) {
                    superstar.overness += overnessChange;
                } else {
                    // Change if close to max value
                    superstar.overness += getRandomInt(-2, 0);
                }

                // Make sure overness is a percentage between 0 and 100
                superstar.overness = limitValueBetweenRange(superstar.overness, 0, 100);

                let hotCheck = checkObjectHot(superstar, 0);
                let staleCheck = checkObjectStale(superstar, 0);
                if (company.userControlled) {
                    if (hotCheck === 'hot') {
                        let newMessage = await createTrainingRosterHotMessage(superstar, month, year, trainer);
                        await addCompanyMessages(company, [newMessage]);
                    }
                    if (staleCheck === 'stale') {
                        let newMessage = await createTrainingRosterStaleMessage(superstar, month, year, trainer);
                        await addCompanyMessages(company, [newMessage]);
                    }
                }
            }

            // Update morale
            if (superstar.morale > 20 && superstar.morale < 80) {
                updateSuperstarMorale(superstar, getRandomInt(-1, 1));
            }

            if (superstar.injured >= 1) {
                superstar.injured -= 1;
                if (superstar.injured === 0) {
                    endSuperstarInjury(superstar);
                }
            }

            // Update suspended superstars
            if (superstar.suspensionMonths > 0) {
                superstar.suspensionMonths -= 1;
            }
        }

        // Add message of top training superstar popularity changes
        if (company.userControlled && maxPopularityGainedSuperstars.length > 0) {
            let popCeiling = changesDict['normal'][trainingFacilityLevel]['pop'][1];
            let newMessage = await createTrainingRosterPopularityMessage(maxPopularityGainedSuperstars, popCeiling,
                month, year, trainer);
            await addCompanyMessages(company, [newMessage]);
        }

        // Update indie superstars
        if (isMainCompany) {

            for (let x of indieAvailableSuperstars) {
                if (x.availableThisMonth) {
                    x.availableThisMonth = null;
                }
            }

            // Check indie future superstars
            let indieFutureRoster = await getCompanyRosterByType(company, 'indieFuture');
            if (indieFutureRoster) {
                let toAdd = await getFutureSuperstarsToAdd(indieFutureRoster, month, year);
                for (let x of toAdd) {
                    if (game.settings['all_indies_available']) {
                        await addFutureSuperstar(x, indieAvailableRoster);
                        x.availableThisMonth = true;
                    } else {
                        await addFutureSuperstar(x, indieRoster);
                    }

                    // Add message
                    let newMessage = await createFutureSuperstarMessage(x, month, year, staffMembers, company, 'Indie');
                    await addCompanyMessages(company, [newMessage]);
                }
            }

            // Make indie superstars available/unavailable
            let madeAvailable = [];
            if (indieSuperstars.length > 0 && getRandomInt(0, 100) <= 70) {
                const talentToTransfer = getRandomChoice(indieSuperstars);
                madeAvailable = await transferTalentToRoster(talentToTransfer, indieAvailableRoster);
            }
            let madeUnavailable = [];
            if (indieAvailableSuperstars.length > 0 && getRandomInt(0, 100) <= 30) {
                if (!game.settings['all_indies_available']) {
                    const talentToTransfer = getRandomChoice(indieAvailableSuperstars);
                    madeUnavailable = await transferTalentToRoster(talentToTransfer, indieRoster);
                }
            }

            // Update indie superstars
            for (let x of madeAvailable) {
                if (objectInArray(x, indieSuperstars)) {
                    indieSuperstars.splice(indieSuperstars.indexOf(x), 1);
                }
                if (!objectInArray(x, indieAvailableSuperstars)) {
                    indieAvailableSuperstars.push(x);
                }
                x.availableThisMonth = true;
                // Add scout message
                let scout = getRandomStaffMemberByRole(staffMembers, 'scout');
                if (scout) {
                    let superstarTagTeam = (await getSuperstarTagTeams(x)).find(y => !y.temporary);
                    let newMessage = await createIndieSuperstarAvailableMessage(x, superstarTagTeam, month, year, scout);
                    await addCompanyMessages(company, [newMessage]);
                }
            }

            for (let x of madeUnavailable) {
                if (!objectInArray(x, indieSuperstars)) {
                    indieSuperstars.push(x);
                }
                if (objectInArray(x, indieAvailableSuperstars)) {
                    indieAvailableSuperstars.splice(indieAvailableSuperstars.indexOf(x), 1);
                }
            }

            // Remove available indie superstar's interested relationships
            for (let superstar of indieAvailableSuperstars) {
                if (getRandomInt(0, 100) <= 50) {
                    let interestedRelationship = (await getSuperstarRelationships(superstar)).find(x => x.interested);
                    if (interestedRelationship) {
                        await Relationships.remove(interestedRelationship)
                    }
                }
            }

            for (let superstar of indieSuperstars.concat(indieAvailableSuperstars)) {

                // Change popularity/overness for active indie superstars
                if (checkAvailability(superstar, true)) {
                    let change = getRandomInt(-10, 10);
                    superstar.popularity += change;

                    // Get overness change
                    let overnessChange = getRandomInt(-2, 2);

                    // Get trait multiplier for overness change
                    for (let trait of superstar.traits) {
                        let traitData = traitsData[trait];
                        if (traitData && traitData['overness_increase_multiplier']) {
                            if (overnessChange > 0) {
                                overnessChange *= traitData['overness_increase_multiplier'];
                            }
                        }
                        if (traitData && traitData['overness_decrease_multiplier']) {
                            if (overnessChange < 0) {
                                overnessChange *= traitData['overness_decrease_multiplier'];
                            }
                        }
                    }

                    // Change overness
                    superstar.overness += overnessChange;
                    superstar.overness = limitValueBetweenRange(superstar.overness, 0, 100);
                    checkObjectHot(superstar, 0);
                    checkObjectStale(superstar, 0);
                }

                // Update injured
                if (superstar.injured >= 1) {
                    superstar.injured -= 1;
                    if (superstar.injured === 0) {
                        endSuperstarInjury(superstar);
                    }
                }

                // Update suspension months
                if (superstar.suspensionMonths > 0) {
                    superstar.suspensionMonths -= 1;
                }

                // Chance to turn superstar
                if (getRandomInt(0, 100) <= 1) {
                    let alignmentChoices = ['face', 'heel', null];
                    if (!superstar.alignment) {
                        alignmentChoices.splice(alignmentChoices.indexOf(null), 1);
                    } else {
                        alignmentChoices.splice(alignmentChoices.indexOf(superstar.alignment), 1);
                    }
                    await turnRosterMember(superstar, getRandomChoice(alignmentChoices), company);
                } else {
                    superstar.alignmentMonths += 1;
                }
            }

            // Add new superstar to indie roster
            if (game.settings['generate_indie_superstars'] !== false && getRandomInt(0, 100) < 33) {
                let generatedSuperstar = await generateSuperstar({popularity: getRandomInt(550, 750), patreonChance: true});

                // Don't add duplicate
                let indieSuperstarsNames = indieSuperstars.concat(indieAvailableSuperstars).map(y => y.name);
                if (!indieSuperstarsNames.includes(generatedSuperstar.name)) {

                    let scout = getRandomStaffMemberByRole(staffMembers, 'scout');
                    let maxScout = getHighestLevelStaffMemberByRole(staffMembers, 'scout');

                    // Auto recruit
                    if (maxScout && maxScout.level >= 3 && scoutingFacility && scoutingFacility.level >= 3) {
                        await addRosterSuperstars(indieAvailableRoster, [generatedSuperstar]);
                        let newMessage = await createNewIndieSuperstarRecruitedMessage(generatedSuperstar, month, year, maxScout);
                        await addCompanyMessages(company, [newMessage]);
                        generatedSuperstar.availableThisMonth = true;

                        // Add xp
                        let xp = 5;
                        let ageMultiplier = getStaffAgeMultiplier(maxScout);
                        xp = Math.round(xp * ageMultiplier);
                        let scoutLevelIncrease = await updateStaffMemberXp(maxScout, xp, company, game);
                        if (scoutLevelIncrease) {
                            data['staffSkillIncreases'].push({
                                name: maxScout.name, level: maxScout.level, role: maxScout.role
                            });
                        }

                        // Add task completed data
                        data['staffActionsCompleted'].push({
                            name: 'recruited a new Indie Talent', xpGained: xp, staffMember: maxScout.name,
                            xpAgeMultiplier: ageMultiplier
                        });
                    }
                    // Add to indie roster
                    else {
                        if (game.settings['all_indies_available']) {
                            await addRosterSuperstars(indieAvailableRoster, [generatedSuperstar]);
                            generatedSuperstar.availableThisMonth = true;
                        } else {
                            await addRosterSuperstars(indieRoster, [generatedSuperstar]);
                        }
                        let newMessage = await createNewIndieSuperstarMessage(generatedSuperstar, month, year, scout);
                        await addCompanyMessages(company, [newMessage]);
                    }
                }
            }
        }
    }

    // Update time-based championships
    data['expiringChampionships'] = [];
    data['expiredChampionships'] = [];
    if (!weeklyShow) {
        for (const championship of companyChampionships) {
            if (championship.championshipContract) {
                championship.monthsToExpire -= 1;

                // Delete championship after 12 months
                if (championship.monthsToExpire < 0) {
                    data['expiredChampionships'].push(getChampionshipDisplayName(championship));
                    const champion = await getChampionshipSuperstar(championship);
                    if (champion) {
                        await removeSuperstarChampionships(champion, [championship]);
                    }
                    await removeCompanyChampionships(company, [championship]);
                    await Championships.remove(championship);
                } else if (championship.monthsToExpire === 0) {
                    data['expiringChampionships'].push(getChampionshipDisplayName(championship));
                }
            }
        }
    }

    // Go through event's match contracts, checking if used
    if (!weeklyShow) {
        for (const matchContract of (await getEventMatchContracts(parentEvent))) {
            // Check if awarded and available for use (i.e not awarded at this event)
            if (matchContract.awarded && matchContract.availableForUse) {
                // Check if championship match held
                const matchContractHolder = await getMatchContractTalent(matchContract);
                let used = false;
                for (const match of (await getEventMatches(latestEvent))) {
                    if ((await getMatchChampionships(match)).length > 0 &&
                        objectInArray(matchContractHolder, (await getMatchParticipants(match)))) {
                        used = true;
                    }
                }
                if (!used) {
                    // Add fans penalty
                    const penalty = getMatchContractNotHeldPenalty(company.reputation);
                    company.fans -= penalty;
                    data['matchContractsNotUsed'].push({matchContract: matchContract.name, penalty: penalty});
                }

                // Remove match contract championship(s) if found
                const matchContractChampionship = await getMatchContractChampionship(matchContract);
                if (matchContractChampionship) {
                    const matchContractChampionships = companyChampionships
                        .filter(x => checkAreChampionshipsEqual(x, matchContractChampionship));
                    for (const c of matchContractChampionships) {
                        await removeCompanyChampionships(company, [c]);
                        await Championships.remove(c);
                    }
                }

                // Delete match contract
                await MatchContracts.remove(matchContract);
            }
        }
    }

    // Make all match contracts available for use
    for (const event of parentEvents) {
        for (const matchContract of (await getEventMatchContracts(event))) {
            if (!matchContract.availableForUse) {
                matchContract.availableForUse = true;
            }
        }
    }

    // Check for event rating goal
    if (company.userControlled && !weeklyShow) {
        let objectiveCompleted = await changeProperty({
            name: 'events', change: 1, company: company, rating: rating
        });
        if (objectiveCompleted) {
            await processObjectiveCompleted(objectiveCompleted, company);
        }
    }

    // Add rating news, messages from competitors, random news
    if (!weeklyShow) {
        if (rating >= 4.25) {
            let newsItem = await generateNewsItem({
                company: company, month: game.newsMonth, year: game.newsYear, event: latestEvent, newsType: 'high_event_rating'
            });
            await addCompanyNewsItems(mainCompany, [newsItem]);

            if (company.userControlled && game.competitorsPresent && getRandomInt(0, 100) <= 15) {
                const competitors = await getCpuControlledCompanies(company, game);
                if (competitors.length) {
                    const competitor = getRandomChoice(competitors);
                    const subject = 'Good show';
                    const content = `<p>That was a pretty good show top to bottom. But I think you can do better, maybe you could even come up to our level.</p>`;
                    const messageFrom = competitor.ownerName ? competitor.ownerName : `Owner - ${competitor.name}`;
                    const newMessage = await createMessage(subject, messageFrom, month, year, content);
                    await addCompanyMessages(company, [newMessage]);
                }
            }
        }
        else if (rating < 2.5) {
            let newsItem = await generateNewsItem({
                company: company, month: game.newsMonth, year: game.newsYear, event: latestEvent, newsType: 'low_event_rating'
            });
            await addCompanyNewsItems(mainCompany, [newsItem]);

            if (company.userControlled && game.competitorsPresent && getRandomInt(0, 100) <= 15) {
                const competitors = await getCpuControlledCompanies(company, game);
                if (competitors.length) {
                    const competitor = getRandomChoice(competitors);
                    const subject = 'Tough luck';
                    const content = `<p>That wasn't a good show, huh? Bad matches, bad stories. Stuff like that happens. I'm sure you'll do better next time.</p>`;
                    const messageFrom = competitor.ownerName ? competitor.ownerName : `Owner - ${competitor.name}`;
                    const newMessage = await createMessage(subject, messageFrom, month, year, content);
                    await addCompanyMessages(company, [newMessage]);
                }
            }
        }

        // Generate random news
        if (getRandomInt(0, 100) <= 6 && game.competitorsPresent) {

            // Rib
            if (getRandomChoice([true, false])) {
                let ribVictim = getRandomChoice(rosterSuperstars);
                let ribCulprit = getRandomChoice(rosterSuperstars);
                while (ribCulprit.$loki === ribVictim.$loki) {
                    ribCulprit = getRandomChoice(rosterSuperstars);
                }
                let newsItem = await generateNewsItem({
                    company: company, month: game.newsMonth, year: game.newsYear, newsType: 'rib', ribVictim: ribVictim,
                    ribCulprit: ribCulprit
                });
                await addCompanyNewsItems(mainCompany, [newsItem]);

                // Add feud
                const newFeudSuperstars = [ribVictim, ribCulprit];
                const feudItems = (await getCompanyFeudItems(company)).filter(x => x.unlocked && x.requirement === 'rib');
                const feudItem = getRandomChoice(feudItems);

                // Check for existing feud
                let existingFeud;
                for (const y of newFeudSuperstars) {
                    for (const f of (await getRosterMemberFeuds(y))) {
                        if ((f.started && !f.ended) || (!f.started && f.directFeudEvent && !f.ended)) {
                            if ((await getFeudParticipants(f)).every(y => objectInArray(y, newFeudSuperstars))) {
                                existingFeud = f;
                                break;
                            }
                        }
                    }
                }

                // Add feud or increase hype of existing feud
                if (!existingFeud) {
                    const newFeud = Feud();
                    await Feuds.insert(newFeud);
                    newFeud.name = feudItem.name;
                    newFeud.hype = feudItem.baseHype;
                    newFeud.participants = newFeudSuperstars.map(s => s.name);
                    newFeud.directFeudEvent = feudItem.requirement;
                    newFeud.startMonth = month;
                    newFeud.startYear = year;
                    data['feudPotential'] = {
                        name: newFeud.name,
                        participants: newFeudSuperstars.map(x => x.name),
                    };
                    await addFeudItemFeuds(feudItem, [newFeud]);
                    await addRosterFeuds(mainRoster, [newFeud]);
                    await addFeudSuperstars(newFeud, newFeudSuperstars);
                }
                else {
                    const hypeIncrease = Math.floor(feudItem.baseHype / 2);
                    existingFeud.hype += hypeIncrease;
                    data['feudHypeIncreased'] = {
                        name: existingFeud.name,
                        participants: newFeudSuperstars.map(x => x.name),
                        hypeIncrease: hypeIncrease,
                        newFeud: feudItem.name,
                    };
                }
            }
            // Superstar venture
            else {
                let newsItem = await generateNewsItem({
                    company: company, month: game.newsMonth, year: game.newsYear, newsType: 'superstar_venture',
                    superstar: getRandomChoice(rosterSuperstars)
                });
                await addCompanyNewsItems(mainCompany, [newsItem]);
            }
        }
    }

    // Ensure max/min overness
    for (const superstar of rosterSuperstars) {
        superstar.overness = limitValueBetweenRange(superstar.overness, 0, 100);
    }

    // Get superstars and championships booked at next event if at tournament/cash in weekly show
    const bookedSuperstars = [];
    const bookedChampionships = [];
    let nextEventMatches = [];
    if (latestEvent.name === 'Weekly Show') {
        const nextEvent = (await getCompanyEvents(company)).reverse()
            .find(event => event.name !== 'Weekly Show' && !event.temporaryEvent);
        if (nextEvent) {
            nextEventMatches = await getEventMatches(nextEvent);
        }
    }
    if (nextEventMatches.length) {
        for (const nextEventMatch of nextEventMatches) {
            bookedSuperstars.push(...(await getAllSuperstarsForMatch(nextEventMatch)));
            bookedChampionships.push(...(await getMatchChampionships(nextEventMatch)));
        }
    }

    // Remove temporary tag teams if not booked
    let temporaryTagTeams = (await getRosterTagTeams(mainRoster)).filter(x => x.temporary);
    for (const tagTeam of temporaryTagTeams) {
        let ts = await getTagTeamSuperstars(tagTeam);
        if (!ts.every(x => objectInArray(x, bookedSuperstars))) {
            await removeTagTeam(tagTeam);
        }
    }

    // Set booked to false for championships
    for (const championship of companyChampionships) {
        if (!objectInArray(championship, bookedChampionships)) {
            championship.booked = false;
        }
    }

    // Reset superstars' attires to base attires
    for (const superstar of rosterSuperstars) {
        if (superstar.currentAttire > 0) {
            superstar.currentAttire = 0;
        }
    }

    // End old feuds
    if (!weeklyShow) {
        for (const feud of (await getRosterFeuds(mainRoster))) {
            if (feud.startMonth !== null && !feud.ended) {
                try {
                    const monthsPassed = getMonthsDifference(month, year, feud.startMonth, feud.startYear);
                    let maximumMonths = 14;
                    if (feud.hot) {
                        maximumMonths = 20;
                    } else if (feud.stale) {
                        maximumMonths = 10;
                    }

                    const feudData = {
                        name: feud.name,
                        participants: (await getFeudParticipants(feud)).map(x => x.name)
                    };

                    // End feud
                    if (monthsPassed >= maximumMonths) {
                        feud.ended = true;

                        // For ending potential feuds
                        if (!feud.started) {
                            feud.rating = null;
                        } else {
                            feud.rating = await getFeudRating(feud);
                        }

                        feud.endMonth = month;
                        feud.endYear = year;

                        // Add message from owner about ending feud
                        if (company.userControlled) {
                            const newMessage = await createFeudEndedMessage(feudData, company, month, year);
                            await addCompanyMessages(company, [newMessage]);
                        }
                    }
                    // Notify user that feuds will be ended next month
                    else if (monthsPassed === maximumMonths - 1 && company.userControlled) {
                        const newMessage = await createEndFeudReminderMessage(feudData, company, month, year);
                        await addCompanyMessages(company, [newMessage]);
                    }
                } catch (error) {
                    captureError(error)
                }
            }
        }
    }

    // Add random messages
    if (company.userControlled && !weeklyShow && company.storyName !== 'mars') {
        if (getRandomInt(0, 100) <= 15 && rosterSuperstars.length) {
            const newMessage = await generateRamblingMessage(rosterSuperstars, company);
            if (newMessage) {
                await addCompanyMessages(company, [newMessage]);
            }
        }
    }

    // Run staff tasks
    const staffTasksCompleted = [];
    const availableStaffMembers = getAvailableStaffMembers(staffMembers);
    if (!weeklyShow) {

        // Run scout/recruit tasks separately
        const scouts = availableStaffMembers.filter(x => x.role === 'scout');
        for (const scout of scouts) {

            if (scout.currentTask && ['Scouting', 'Recruiting'].includes(scout.currentTask.split(' ')[0])) {
                // Get talent from indie roster
                const talentName = scout.currentTask.split(' ').splice(1).join(' ');
                let talent = indieSuperstars.concat(indieAvailableSuperstars).find(x => x.name === talentName);
                if (!talent) {
                    talent = (await getRosterTagTeams(indieRoster)).concat(await getRosterTagTeams(indieAvailableRoster))
                        .find(x => x.name === talentName);
                }

                if (talent) {
                    // Run task
                    const task = scout.currentTask.split(' ')[0];
                    let xp = 0;
                    const ageMultiplier = getStaffAgeMultiplier(scout);

                    if (task === 'Scouting') {
                        await scoutTalent(talent, indieRoster, indieAvailableRoster, scout, company);
                        xp = 7.5;
                    } else if (task === 'Recruiting') {
                        await recruitTalent(talent, indieRoster, indieAvailableRoster, scout, company);
                        xp = 5;
                    }

                    if (task === 'Scouting' || task === 'Recruiting') {
                        // Add actions completed (Superstars Scouted/Recruited)
                        await checkFacilityUpgrade('Scouting', company);
                    }

                    // Add xp
                    xp = Math.round(xp * ageMultiplier);
                    const scoutLevelIncrease = await updateStaffMemberXp(scout, xp, company, game);
                    if (scoutLevelIncrease) {
                        data['staffSkillIncreases'].push({
                            name: scout.name, level: scout.level, role: scout.role
                        });
                    }

                    // Add task completed data
                    staffTasksCompleted.push({
                        name: scout.currentTask, xpGained: xp, staffMember: scout.name, xpAgeMultiplier: ageMultiplier
                    });
                }

                scout.currentTask = null;
            }
            // Build interest
            else if (scout.level >= 2 && scoutingFacility && scoutingFacility.level >= 2) {
                const superstarInterested = await buildInterest(indieAvailableSuperstars, scout, company);

                if (superstarInterested) {
                    // Add xp
                    let xp = 5;
                    const ageMultiplier = getStaffAgeMultiplier(scout);
                    xp = Math.round(xp * ageMultiplier);
                    const scoutLevelIncrease = await updateStaffMemberXp(scout, xp, company, game);
                    if (scoutLevelIncrease) {
                        data['staffSkillIncreases'].push({
                            name: scout.name, level: scout.level, role: scout.role
                        });
                    }

                    // Add task completed data
                    data['staffActionsCompleted'].push({
                        name: 'got an Indie Talent interested', xpGained: xp, staffMember: scout.name,
                        xpAgeMultiplier: ageMultiplier
                    });
                }
            }
        }

        const transitionedStaffMembers = [];
        for (const staffMember of staffMembers) {
            // Progress tasks that run with time
            if (staffMember.currentTask && staffMember.monthsLeftForTask &&
                staffMember.unavailableMonths <= 0 && !staffMember.retired) {

                // Check task end
                if (staffMember.monthsLeftForTask <= 1) {
                    let task = staffMember.currentTask.split(' ')[0];
                    if (task === 'Training') {
                        task = staffMember.currentTask.split(' ').slice(0, 2).join(' ');  // Get next word which is skill in brackets
                    }
                    let runTaskOn = null;

                    // Get talent name
                    let talentName = staffMember.currentTask.split(task + ' ')[1];
                    if (task === 'Unlearning') {
                        talentName = staffMember.currentTask.split(' For ')[1];
                    }
                    if (task === 'Transitioning') {
                        if (staffMember.currentTask.split(' ')[1] === '(Staff)') {
                            task = 'Transitioning (Staff)';
                            talentName = staffMember.currentTask.split(' (Staff) ')[1];
                        } else if (staffMember.currentTask.split(' ')[1] === '(Talent)') {
                            task = 'Transitioning (Talent)';
                            talentName = staffMember.currentTask.split(' (Talent) ')[1];
                        }
                    }

                    // Get talent
                    if (['Training (Workrate)', 'Training (Charisma)', 'Reassuring', 'Transitioning',
                        'Unlearning', 'Transitioning (Staff)'].includes(task)) {
                        runTaskOn = rosterSuperstars.find(x => x.name === talentName);
                    } else if (task === 'Preparing') {
                        runTaskOn = allTrainingSuperstars.find(x => x.name === talentName);
                    } else if (task === 'Negotiating') {
                        const competitorName = staffMember.currentTask.split(' ')
                            .slice(1, staffMember.currentTask.split(' ').length - 1).join(' ');
                        const allCompetitors = await getActiveCompetitorsForCompany(company, game);
                        runTaskOn = allCompetitors.find(x => x.name === competitorName);
                    } else if (task === 'Transitioning (Talent)') {
                        runTaskOn = staffMembers.find(x => x.name === talentName);
                    }

                    if (runTaskOn) {
                        // Run task
                        let xp = 0;
                        const ageMultiplier = getStaffAgeMultiplier(staffMember);

                        // Training
                        if (['Training (Workrate)', 'Training (Charisma)'].includes(task)) {
                            let skill = null;
                            if (task === 'Training (Workrate)') {
                                skill = 'workrate'
                            } else if (task === 'Training (Charisma)') {
                                skill = 'charisma'
                            }
                            await trainTalent(runTaskOn, skill, staffMember, company, staffMembers);
                            xp = 22.5;

                            // Add actions completed (Superstars Trained)
                            await checkFacilityUpgrade('Training', company);
                        }
                        // Preparing
                        else if (task === 'Preparing') {
                            await makeTrainingTalentAvailable(runTaskOn, staffMember, trainingAvailableRoster, company);
                            xp = 15;
                        }
                        // Negotiating Buyout
                        else if (task === 'Negotiating') {
                            runTaskOn.operatingStatus = `Running Buyout by ${company.name}`;
                            xp = 50;
                        }
                        // Reassuring
                        else if (task === 'Reassuring') {
                            await reassureTalent(runTaskOn, staffMember, company);
                            xp = 5;

                            // Add actions completed (Superstars Reassured)
                            await checkFacilityUpgrade('Talent Management', company);
                        }
                        // Transitioning
                        else if (task === 'Transitioning') {
                            await transitionTalent(runTaskOn, staffMember, company);
                            xp = 8;
                        }
                        // Unlearning
                        else if (task === 'Unlearning') {
                            await unlearnTalentTrait(runTaskOn, staffMember, company);
                            xp = 40;
                        }
                        // Transitioning to staff
                        else if (task === 'Transitioning (Staff)') {
                            await transitionSuperstarToStaffMember(runTaskOn, staffMember, company);
                            xp = 15;
                            // Remove from roster superstars
                            rosterSuperstars = rosterSuperstars.filter(x => x.$loki !== runTaskOn.$loki);
                        }
                        // Transitioning to superstar
                        else if (task === 'Transitioning (Talent)') {
                            await transitionStaffMemberToSuperstar(runTaskOn, staffMember, company);
                            xp = 15;
                            transitionedStaffMembers.push(runTaskOn);
                        }

                        // Add xp
                        xp = Math.round(xp * ageMultiplier);
                        const staffMemberLevelIncrease = await updateStaffMemberXp(staffMember, xp, company, game);
                        if (staffMemberLevelIncrease) {
                            data['staffSkillIncreases'].push({
                                name: staffMember.name, level: staffMember.level, role: staffMember.role
                            });
                        }

                        // Add task completed data
                        staffTasksCompleted.push({
                            name: staffMember.currentTask, xpGained: xp, staffMember: staffMember.name,
                            xpAgeMultiplier: ageMultiplier
                        });
                    }

                    removeStaffTaskData(staffMember);
                }
                else {
                    staffMember.monthsLeftForTask -= 1;

                    // Buyout accepted message before task ends
                    const task = staffMember.currentTask.split(' ')[0];
                    if (task === 'Negotiating' && staffMember.monthsLeftForTask === 1) {
                        const competitorName = staffMember.currentTask.split(' ')
                            .slice(1, staffMember.currentTask.split(' ').length - 1).join(' ');
                        const allCompetitors = await getActiveCompetitorsForCompany(company, game);
                        const competitor = allCompetitors.find(x => x.name === competitorName);
                        if (competitor) {
                            const competitorMainRoster = await getCompanyRosterByType(competitor, 'main');
                            const competitorSuperstars = await getRosterSuperstars(competitorMainRoster);
                            const [available, notAvailable] = await getBuyoutSuperstars(competitor, competitorSuperstars,
                                company);
                            available.sort((a, b) => b.popularity - a.popularity);
                            notAvailable.sort((a, b) => b.popularity - a.popularity);

                            // From top not available superstar
                            let newMessage = await createBuyoutNotAvailableSuperstarMessage(
                                getRandomChoice(notAvailable.slice(0, 5)), month, year
                            );
                            await addCompanyMessages(company, [newMessage]);

                            // Message from trainer
                            const trainer = getHighestLevelStaffMemberByRole(staffMembers, 'trainer');
                            newMessage = await createBuyoutAcceptedTrainerMessage(competitor, month, year, trainer);
                            await addCompanyMessages(company, [newMessage]);

                            // Message from owner
                            newMessage = await createBuyoutSigningsMessage(competitor, month, year, company.ownerName);
                            await addCompanyMessages(company, [newMessage]);

                            // Message from talent manager
                            newMessage = await createBuyoutAcceptedMessage(
                                competitor, competitorSuperstars, available, notAvailable, month, year, staffMember
                            );
                            await addCompanyMessages(company, [newMessage]);
                        }
                    }
                }
            }

            // Progress unavailability
            if (staffMember.unavailableMonths > 0) {
                staffMember.unavailableMonths--;
            }
        }

        // Update staff
        staffMembers = staffMembers.filter(x => !objectInArray(x, transitionedStaffMembers));
    }

    // Remove producer segment focus tasks
    const producers = staffMembers.filter(x => x.role === 'producer');
    for (const producer of producers) {
        if (producer.currentTask && producer.taskData && producer.taskData['segment_id']) {
            removeStaffTaskData(producer);
        }

        // Check producer segment unlocks
        checkProducerSegmentItemsToUnlock(producer, companySegmentItems);
    }

    // Remove doctor rehab tasks
    const doctors = staffMembers.filter(x => x.role === 'doctor');
    for (const doctor of doctors) {
        if (doctor.currentTask && doctor.taskData && doctor.taskData['talent_id']) {
            const doctorTalent = rosterSuperstars.find(y => y.$loki === doctor.taskData['talent_id']);
            if (!doctorTalent || doctorTalent.injured === 0) {
                removeStaffTaskData(doctor);
            }
        }
    }

    // Update staff age and check for retirement
    if (newYearStarted) {
        for (const staffMember of staffMembers) {
            staffMember.age += 1;

            if (!game.settings['no_retirements']) {
                // Retirement chance message
                if (staffMember.age === 65) {
                    if (company.userControlled) {
                        const newMessage = await createStaffMemberRetirementChanceMessage(staffMember, month, year);
                        await addCompanyMessages(company, [newMessage]);
                    }
                }
                // Retirement chance
                else if (staffMember.age > 65 && !staffMember.retired) {
                    const task = staffMember.currentTask ? staffMember.currentTask.split(' ')[0] : null;
                    if (getRandomInt(0, 100) <= 25 && task !== 'Negotiating') {
                        // Retire
                        staffMember.retired = true;
                        removeStaffTaskData(staffMember);
                        staffMember.unavailableMonths = 0;

                        if (company.userControlled) {
                            const newCompanyAlert = await createCompanyAlert(
                                'staffMemberRetired', `${staffMember.name} (${toTitleCase(staffMember.role.replace('_', ' '))})`);
                            await addCompanyCompanyAlerts(company, [newCompanyAlert]);

                            const newMessage = await createStaffMemberRetirementMessage(staffMember, month, year);
                            await addCompanyMessages(company, [newMessage]);
                        }
                    }
                }
            }
        }

        if (isMainCompany) {
            for (const staffMember of (await getRosterStaff(indieAvailableRoster))) {
                staffMember.age += 1;

                if (!game.settings['no_retirements']) {
                    // Retirement chance
                    if (staffMember.age > 65 && !staffMember.retired) {
                        if (getRandomInt(0, 100) <= 25) {
                            // Retire
                            staffMember.retired = true;
                            removeStaffTaskData(staffMember);
                            staffMember.unavailableMonths = 0;

                            // Generate new staff member
                            const newStaffMember = await generateStaffMember(staffMember.role, getRandomChoice([1, 2, 3]));
                            await addRosterStaff(indieAvailableRoster, [newStaffMember]);
                        }
                    }
                }
            }
        }
    }

    // Staff random events
    if (!weeklyShow) {
        if (availableStaffMembers.length) {
            await checkForStaffRandomEvent(availableStaffMembers, company);
        }
    }

    // Manage morale
    for (const superstar of rosterSuperstars) {
        // Don't process for injured, suspended, retired, no appearances part timers and on trade deal superstars
        if (!checkAvailability(superstar, true, false, false)
            || superstar.activeEffect === 'traded' || superstar.name === company.ownerName) {
            continue;
        }
        await processSuperstarMorale(superstar, company, game);
    }

    // Make all superstars available
    for (const s of rosterSuperstars) {
        if (s.unavailable) {
            s.unavailable = false;
        }
    }

    // Process temporary graphics
    if (!annualTournamentRunning) {
        for (const s of rosterSuperstars.concat(indieSuperstars, indieAvailableSuperstars, allTrainingSuperstars)) {
            processSuperstarTemporaryInjury(s, latestEvent);
            if (!weeklyShow) {
                processSuperstarTemporaryTrophy(s);
            }
        }
    }

    // Recover fatigue for all superstars
    let superstarsToRecoverFatigue = [...rosterSuperstars];
    if (isMainCompany) {
        superstarsToRecoverFatigue = superstarsToRecoverFatigue.concat(indieSuperstars, indieAvailableSuperstars,
            allTrainingSuperstars);
    }
    if (annualTournamentRunning) {
        // Recover fatigue for participating superstars only at annual tournament
        superstarsToRecoverFatigue = [...superstarsUsedAtEvent];
    }
    for (const s of superstarsToRecoverFatigue) {
        const usedAtEvent = objectInArray(s, superstarsUsedAtEvent);
        recoverSuperstarFatigue(s, usedAtEvent, weeklyShow, rosterBrands, game);

        // Limit fatigue to percentage
        s.fatigue = limitValueBetweenRange(s.fatigue, 0, 100);
    }

    // Remove temporary segment items
    const segmentItemsToRemove = companySegmentItems.filter(x => x.temporary);
    for (const segmentItem of segmentItemsToRemove) {
        await removeCompanySegmentItems(company, [segmentItem]);
    }

    // Booking effects for competitors
    if (!company.userControlled && !weeklyShow && mainCompany.storyName !== 'mars') {
        const bookingEffects = ['good_booking', 'bad_booking'];
        let activeEffect = company.activeEffect;

        // Chance to add booking effect
        if (!activeEffect && getRandomInt(0, 100) <= 10) {
            company.activeEffect = weightedChoice([['good_booking', 50], ['bad_booking', 50]]);
        }

        // Chance to remove booking effect
        if (bookingEffects.includes(activeEffect)) {
            if (getRandomInt(0, 100) <= 10) {
                company.activeEffect = null;
            } else if (company.activeEffect === 'good_booking' && rating < 3.5 && getRandomInt(0, 100) <= 25) {
                company.activeEffect = null;
            } else if (company.activeEffect === 'bad_booking' && rating > 3.5 && getRandomInt(0, 100) <= 25) {
                company.activeEffect = null;
            }
        }

        // Chance to add good booking effect if available for buyout
        if (company.operatingStatus === 'Buyout Available' && getRandomInt(0, 100) <= 60) {
            company.activeEffect = 'good_booking';
        }
    }

    // Check if special segment items are available to re-use if not sandbox mode
    if (!weeklyShow) {
        if (!company.userControlled || !game.settings['no_special_items_cooldown']) {
            for (const x of companySegmentItems) {
                if (x.special && x.unlocked && x.used) {
                    x.monthsToReuse -= 1;
                    if (x.monthsToReuse <= 0) {
                        x.used = false;
                        x.monthsToReuse = 36;

                        // Add re-use message
                        if (company.userControlled) {
                            const newMessage = await createSpecialSegmentReuseMessage(x, month, year);
                            await addCompanyMessages(company, [newMessage]);
                        }
                    }
                }
            }

            // Check if special finishes are available to re-use
            for (const [_, v] of Object.entries(company.specialFinishesData)) {
                if (v['months_to_reuse'] > 0) {
                    v['months_to_reuse'] -= 1;
                }
            }
        }
    }

    if (!weeklyShow) {
        const sentNegotiations = await getCompanySentNegotiations(company);

        // Process negotiations started by company and accepted by talent, except those sent to user-controlled company
        if (!(company.userControlled && game.settings['control_multiple_companies'])) {
            const acceptedNegotiations = await filterOffersSentToCpuCompanies(sentNegotiations);
            for (const acceptedNegotiation of acceptedNegotiations) {
                let processedNegotiation = await processNegotiation(acceptedNegotiation);
                if (processedNegotiation && processedNegotiation.status === 'accepted_by_company') {
                    const negotiationTalent = await getNegotiationTalent(processedNegotiation);
                    data['signings'].push(negotiationTalent.name);
                }
            }
        }

        // Process negotiations sent to user-controlled company if simulating
        if (simulation && company.userControlled) {

            // Get incoming offers without duplicates for superstars
            const incomingNegotiations = [];
            let incomingNegotiationsTalentNames = [];
            const acceptedNegotiations = (await getCompanyReceivedNegotiations(company))
                .filter(y => y.status === 'accepted_by_talent');
            for (const acceptedNegotiation of acceptedNegotiations) {
                const negotiationTalent = await getNegotiationTalent(acceptedNegotiation);
                if (!incomingNegotiationsTalentNames.includes(negotiationTalent.name)) {
                    incomingNegotiations.push(acceptedNegotiation);
                    incomingNegotiationsTalentNames.push(negotiationTalent.name);
                }
            }

            // Reject offers if simulating game using 'Book' option
            const autoRejectOffers = userSimulatorOption === 'book';
            for (const negotiation of incomingNegotiations) {
                let processedNegotiation = await processNegotiation(negotiation, autoRejectOffers);
                if (processedNegotiation.status === 'accepted_by_company') {
                    let negotiationTalent = await getNegotiationTalent(processedNegotiation);
                    let negotiationSenderCompany = await getNegotiationSenderCompany(processedNegotiation);
                    data['offersAccepted'].push({
                        name: negotiationTalent.name, company: negotiationSenderCompany.name
                    });
                    if (negotiationTalent.objectName === 'superstar' && objectInArray(negotiationTalent, rosterSuperstars)) {
                        rosterSuperstars.splice(rosterSuperstars.indexOf(negotiationTalent), 1);
                    }
                }
            }
        }

        // Remove old negotiations (rejected, finished)
        for (const sentNegotiation of sentNegotiations) {
            if (sentNegotiation.monthsToRemove !== null) {
                sentNegotiation.monthsToRemove -= 1;
                if (sentNegotiation.monthsToRemove <= 0 && sentNegotiation.$loki) {
                    await Negotiations.remove(sentNegotiation)
                }
            }
        }
    }

    // Check if at last user event
    let lastUserEvent = false;
    if (game.settings['control_multiple_companies']) {
        if (company.userControlled && (await getUserControlledCompanies(game))
            .filter(y => y.turnStatus === 'playing').length === 1) {
            lastUserEvent = true;
        }
    } else {
        if (isMainCompany) {
            lastUserEvent = true;
        }
    }

    // Process annual tournament
    if (lastUserEvent) {
        try {
            await processAnnualTournament(game, mainCompany, user, weeklyShow, eventsToSimulate);
        } catch (error) {
            captureError(error)
        }
    }

    // True for monthly event before night 1, night 1 itself, but not night 2
    const annualTournamentActive = annualTournament && (['selecting', 'running'].includes(annualTournament.status));

    // Run random events
    if (company.userControlled && !game.settings['no_random_events'] && !annualTournamentActive) {
        // Mark night 2 of TGI as monthly to process random events
        try {
            await randomEventCheck(company, weeklyShow && !annualTournamentRunning);
        }
        catch (error) {
            captureError(error)
        }
    }

    // Add and process talent requests for user companies, don't in stories
    if (company.userControlled && !mainCompany.storyName) {

        // Process talent requests
        try {
            await processTalentRequests(company, weeklyShow);
        } catch (error) {
            captureError(error)
        }

        // Check to add talent requests after monthly events
        try {
            if (!weeklyShow && globalUser.paid && !game.settings['no_talent_requests'] && !annualTournamentActive) {
                await checkTalentRequestCreation(company, rosterSuperstars, mainRoster, companyChampionships);
            }
        } catch (error) {
            captureError(error)
        }
    }

    // Process months to form for new company
    if (!weeklyShow && isMainCompany && company.newCompanyData?.monthsToForm !== undefined) {
        company.newCompanyData.monthsToForm -= 1;
    }

    // Add 'shown' to company alerts, delete shown alerts
    if (company.userControlled && !annualTournamentActive) {
        for (const companyAlert of (await getCompanyCompanyAlerts(company))) {
            if (companyAlert.shown) {
                await CompanyAlerts.remove(companyAlert);
            } else {
                companyAlert.shown = true;
            }
        }
    }

    // Add datetime game last played
    if (company.userControlled) {
        game.datetimeLastPlayed = Date.now();
    }

    // Return data
    data['points'] = company.points;
    data['pointsToAdd'] = pointsToAdd;
    data['hype'] = latestEvent.hype;
    if (game.marketSize === null) {
        data['fansGained'] = fansToAdd;
        data['hypeMultiplier'] = hypeMultiplier;
        data['nextReputation'] = fansToNextReputation;
        data['previousReputation'] = fansToPreviousReputation;
        data['reputationIncrease'] = reputationIncrease;
        data['reputationDecrease'] = reputationDecrease;
        data['reputation'] = company.reputation;
        const repXpChange = (company.fans - startingFans) / 100;
        data['reputationXpChange'] = Math.abs(repXpChange) > 10 ? Math.floor(repXpChange) : Math.round(repXpChange * 10) / 10;
        data['reputationXp'] = Math.floor(company.fans / 100);
        data['xpToNextReputation'] = Math.floor(fansToNextReputation / 100);
        data['companyName'] = company.name;
    }
    data['eventPrestige'] = eventPrestigeData;
    data['weeklyShow'] = weeklyShow;
    data['fans'] = company.fans;
    data['rating'] = rating;
    data['staffTasksCompleted'] = staffTasksCompleted;
    data['skipSimulateCompetitors'] = latestEvent.name === 'Weekly Show' || latestEvent.temporaryEvent;

    // Increase realYear if first monthly event
    if (!(company.userControlled && game.settings['control_multiple_companies']) && latestEvent.name !== 'Weekly Show' &&
        !latestEvent.temporaryEvent) {
        if (!nextEvent.weeklyShow) {
            const nextEventParentEvent = await getParentEventForEvent(parentEvents, nextEvent);
            if (nextEventParentEvent.$loki === parentEvents[0].$loki) {
                company.realYear += 1;
            }
        }
        nextEvent.year = company.realYear;
    }

    // If local multiplayer and not tournament weekly show, end turn, go to next user controlled company
    if (company.userControlled && game.settings['control_multiple_companies'] && latestEvent.name !== 'Weekly Show' &&
        !latestEvent.temporaryEvent) {

        company.turnStatus = 'ended';
        let userControlledCompanies = await getUserControlledCompanies(game);
        let userControlledCompaniesPlaying = userControlledCompanies.filter(y => y.turnStatus === 'playing');

        // If any user is playing
        if (userControlledCompaniesPlaying.length) {
            // Set next company with 'playing' status as current company
            setGameCurrentCompany(game, userControlledCompaniesPlaying[0]);
            // Skip simulate competitors
            data['skipSimulateCompetitors'] = true;

            // Reset game month increase
            if (!weeklyShow) {
                game.monthCount -= 1;
                if (game.monthCount < 0) {
                    game.monthCount = 11;
                    game.year -= 1;
                }
            }
        }

        // If all user turns ended
        else {
            // Check if all user companies at monthly event, for realYear increase
            let allAtMonthlyEvent = true;
            for (const y of userControlledCompanies) {
                if ((await getCompanyLatestEvent(y))?.weeklyShow) {
                    allAtMonthlyEvent = false;
                }
            }

            // Change status of all companies to 'playing', check for end of brand events
            for (let y of userControlledCompanies) {
                y.turnStatus = 'playing';

                // Increase realYear if first event of company and all user companies at monthly event
                let nextCompanyEvent = (await Events.find({'companyId': y.$loki}).reverse()).find(x => !x.temporaryEvent);
                if (allAtMonthlyEvent) {
                    let companyParentEvents = await getCompanyParentEvents(y);
                    let nextEventParentEvent = await getParentEventForEvent(companyParentEvents, nextCompanyEvent);
                    if (nextEventParentEvent && nextEventParentEvent.$loki === companyParentEvents[0].$loki) {
                        y.realYear += 1;
                    }
                }

                // If end of brand events or no brand events, end turn
                let companyMainRoster = await getCompanyRosterByType(y, 'main');
                if (weeklyShow) {
                    let companyRosterBrands = await getRosterBrands(companyMainRoster);
                    let companyBrandIndex = getBrandIndexForWeeklyShow(nextCompanyEvent, companyRosterBrands);
                    if (companyBrandIndex < 1) {
                        y.turnStatus = 'ended';
                    }
                }

                // Set year for next event
                nextCompanyEvent.year = y.realYear;

                // Process negotiations
                let acceptedNegotiations = await filterOffersSentToCpuCompanies((await getCompanySentNegotiations(y)));
                for (let acceptedNegotiation of acceptedNegotiations) {
                    await processNegotiation(acceptedNegotiation);
                }

                if (!weeklyShow) {
                    let onTradeSuperstars = (await getRosterSuperstars(companyMainRoster))
                        .filter(x => x.activeEffect === 'traded');
                    // Process superstars on trade
                    for (let superstar of onTradeSuperstars) {
                        superstar.appearances -= 1;
                        if (superstar.appearances <= 0) {

                            // Transfer superstar
                            const originalRoster = await getSuperstarOriginalRoster(superstar);
                            await addRosterSuperstars(originalRoster, [superstar]);

                            const vacatedChampionships = await vacateChampionships({
                                superstar: superstar, championships: (await getCompanyChampionships(y)), month, year
                            });
                            if (vacatedChampionships.length > 0) {
                                data['vacated'].push(...vacatedChampionships);
                            }

                            // Remove from factions/managers
                            await removeSuperstarFactionRelationships(superstar, month, year);
                            await removeSuperstarManagerRelationships(superstar);

                            // Reset other attributes
                            superstar.brandName = null;
                            superstar.activeEffect = null;
                            if (!superstar.partTimer) {
                                superstar.appearances = null;
                            }

                            data['tradeReturns'].push(superstar.name);
                        }
                    }

                    // Move/remove teams if trade ending
                    for (let superstar of onTradeSuperstars) {
                        if (!superstar.appearances) {
                            for (let tagTeam of [...(await getSuperstarTagTeams(superstar))]) {
                                let ts = await getTagTeamSuperstars(tagTeam);
                                // Move team if all members were on trade together
                                if (ts.every(s => objectInArray(s, onTradeSuperstars) && !s.appearances)) {
                                    await addRosterTagTeams((await getSuperstarOriginalRoster(superstar)), [tagTeam]);
                                }
                                // Otherwise, remove team
                                else {
                                    await removeTagTeam(tagTeam);
                                }
                            }
                        }
                    }
                }
            }

            // If any user playing (when extra brand events)
            userControlledCompaniesPlaying = userControlledCompanies.filter(y => y.turnStatus === 'playing');
            if (userControlledCompaniesPlaying.length) {
                // Set next company with 'playing' status as current company
                setGameCurrentCompany(game, userControlledCompaniesPlaying[0]);
            }
            // If all user turns ended (all brand events completed)
            else {
                // Set game as current company
                game.currentCompanyId = null;
                // Change status of all companies to 'playing'
                for (let y of userControlledCompanies) {
                    y.turnStatus = 'playing';
                }
            }

            // Allow simulating competitors
            game.monthlySimulationRun = false;
        }
    }

    // Remove previous draft (e.g yearly draft created while simulating that wasn't run by user) todo test simulating
    let draft = (await getCompanyDraft(company));
    if (draft) {
        draft.ended = true;
    }

    // Process yearly draft
    try {
        // Run after monthly event if weekly shows are present, otherwise run at monthly event
        if (company.settings['yearly_brand_draft_settings'] &&
            Object.keys(company.settings['yearly_brand_draft_settings']).length !== 0 && !weeklyShow) {
            let currentMonth = await getCurrentMonth(company, parentEvents);
            await checkYearlyDraft(company, currentMonth);
        }
    } catch (error) {
        captureError(error)
    }

    // Process PoW story
    if (company.storyName === 'passion') {
        let storyChoices = (await getCompanyStoryChoices(company)).reverse();

        // Get post event dialog
        data['postEventDialogs'] = getPowPostEventDialogs(storyChoices, rosterSuperstars);

        // Process story choices
        await processPowStoryChoices(storyChoices, company, latestEvent);
    }

    if (company.storyName === 'tutorial') {
        // Force vacate titles if not vacated
        let tutorialState = await getTutorialStateName(company);
        if (tutorialState === 'end_first_event') {
            let s = rosterSuperstars.find(x => x.name === 'Chris Gray');
            if (s) {
                await vacateChampionships({superstar: s, championships: companyChampionships, month, year});
            }
        }
    }

    // Add form new company message
    if (!game.settings['control_multiple_companies'] && company.userControlled && !company.storyName &&
        company.newCompanyData?.monthsToForm === undefined && companyYear === 3 && companyMonth === 0 &&
        (await getGameActiveCompanies(game)).length < gameLimits.maxCompetitors + 1 && !weeklyShow) {
        let newMessage = await createFormingNewCompanyPotentialMessage(generateFormNewCompanyOwnerName(company),
            game.monthCount, game.year);
        await addCompanyMessages(company, [newMessage]);
    }

    if (company.fans < 0) {
        company.fans = 0;
    }
    if (company.points < 0) {
        company.points = 0;
    }

    // Reset creative points in sandbox mode
    if (company.userControlled && game.settings['unlimited_creative_points']) {
        company.points = 100000000;
    }

    // Add to user's events played
    user = loadUser();
    if (isMainCompany && !simulation && user) {
        user.eventsPlayed += 1;
        saveUser(user);
    }

    return data;
}

function getPointsToAdd(rating, weeklyShow = false) {  // get_points_to_add
    let pointsToAdd = 0;
    // Divide rating into 0.25 star divisions
    let divisions = Math.floor(rating / 0.25) + 1;

    // Add points for different rating integer levels
    for (let i = 0; i < divisions; i++) {
        if (i <= 3) {
            pointsToAdd += 1.5;
        } else if (i <= 11) {
            pointsToAdd += 3;
        } else if (i <= 15) {
            pointsToAdd += 10;
        } else if (i <= 19) {
            pointsToAdd += 22.5;
        } else if (i <= 23) {
            pointsToAdd += 30;
        } else {
            pointsToAdd += 30;
        }
    }

    if (weeklyShow) {
        pointsToAdd *= 0.5;
    }

    return Math.floor(pointsToAdd);
}

function getFansToAdd(rating, reputation, hype, weeklyShow = false) {  // get_fans_to_add
    if (reputation >= 10) {
        reputation = 4;
    }

    // Get fans to add
    let formulaRating = rating;
    let multiplier;
    if (formulaRating <= 3.0) {
        multiplier = -2;
        formulaRating = 4.25 - formulaRating;
    } else if (formulaRating <= 3.5) {
        multiplier = 0.25;
    } else if (formulaRating <= 4.5) {
        multiplier = 0.5;
    } else if (formulaRating <= 5) {
        multiplier = 1;
    } else {
        multiplier = 2;
    }

    let reputationMultiplier = 2 ** (reputation / 2);
    let hypeMultiplier = (hype / 40) + 1;

    let fansToAdd = formulaRating ** 2 * multiplier * reputationMultiplier * hypeMultiplier * 20;
    if (weeklyShow) {
        fansToAdd *= 0.3;
    }

    return [myround(fansToAdd, 10), Math.round(hypeMultiplier * 10) / 10];
}

function getCompanyOvernessChange(eventRating, company) {  // get_company_overness_change
    const overnessDict = {
        0.0: -20, 0.25: -20, 0.50: -19, 0.75: -18,
        1.0: -17, 1.25: -16, 1.50: -15, 1.75: -13,
        2.0: -11, 2.25: -10, 2.50: -9, 2.75: -8,
        3.0: -6, 3.25: -4,
        3.50: 1,
        3.75: 2,
        4.0: 4, 4.25: 6, 4.50: 8, 4.75: 10,
        5.0: 11, 5.25: 12, 5.50: 14, 5.75: 15,
        6.0: 16
    };

    let overnessChange = overnessDict[eventRating] || 0;

    // Max overness
    if (eventRating >= 6) {
        overnessChange = Math.max(...Object.values(overnessDict));
    }

    // Reduce overness increase if hot, reduce decrease if stale
    if (company.hot) {
        if (overnessChange > 0) {
            overnessChange /= 5;
        } else {
            overnessChange *= 3;
        }
    }
    if (company.stale) {
        if (overnessChange < 0) {
            overnessChange /= 4;
        } else {
            overnessChange *= 2;
        }
    }

    return Math.floor(overnessChange);
}

function getBrandOvernessChange(eventRating, brand) {  // get_brand_overness_change
    const overnessDict = {
        0.0: -10, 0.25: -10, 0.50: -10, 0.75: -9,
        1.0: -9, 1.25: -8, 1.50: -8, 1.75: -7,
        2.0: -7, 2.25: -6, 2.50: -6, 2.75: -5,
        3.0: -5, 3.25: -4, 3.50: -2, 3.75: 2,
        4.0: 3, 4.25: 4, 4.50: 5, 4.75: 6,
        5.0: 6, 5.25: 7, 5.50: 7, 5.75: 8,
        6.0: 9
    };

    let overnessChange = overnessDict[eventRating] || 0;

    // Max overness
    if (eventRating >= 6) {
        overnessChange = Math.max(...Object.values(overnessDict));
    }

    // Reduce overness increase if hot, reduce decrease if stale
    if (brand.hot) {
        if (overnessChange > 0) {
            overnessChange /= 3;
        } else {
            overnessChange *= 3;
        }
    }
    if (brand.stale) {
        if (overnessChange < 0) {
            overnessChange /= 3;
        } else {
            overnessChange *= 3;
        }
    }

    return Math.floor(overnessChange);
}

async function getMonthsPassedSinceChampionshipMatch(championship, companyChampionships, company, month, year,
                                                     companyMonth, companyYear) {  // get_months_passed_since_championship_match
    // Get latest match from current championship reign
    let latestMatch = null;
    let reign = await getChampionshipCurrentReign(championship);
    if (reign) {
        let reignMatches = (await getChampionshipReignMatches(reign)).reverse();
        if (reignMatches.length > 0) {
            latestMatch = reignMatches[0];
        }
    }

    let monthsPassed;
    if (latestMatch) {
        // Get monthly event of latest match
        let companyMonthlyEvents = (await getCompanyEvents(company)).filter(x => !x.weeklyShow).reverse();
        let matchEvent = await getMatchEvent(latestMatch);
        let monthlyEvent = matchEvent.weeklyShow || matchEvent.name === 'Weekly Show'
            ? companyMonthlyEvents.find(x => x.name === matchEvent.monthlyEventName)
            : matchEvent;

        // Get months passed since monthly event
        monthsPassed = companyMonthlyEvents.indexOf(monthlyEvent);
        if (monthsPassed === -1) {
            monthsPassed = 0;
        }
    } else {
        // If new championship, get months passed after championship created
        let championshipLog = (await getCompanyCompanyLogs(company))
            .find(x => x.type === 'new-championship' && x.text === championship.name);
        if (championshipLog) {
            monthsPassed = getMonthsDifference(month, year, championshipLog.month, championshipLog.realYear);
        }
        // Otherwise get total months passed for company
        else {
            monthsPassed = companyMonth + (companyYear * 12);
        }
    }

    return monthsPassed;
}

function getNotUsedPopularityDecrease(superstar) {  // get_not_used_popularity_decrease
    let popularityDecrease = superstar.popularity * 0.035;
    if (superstar.faceOfTheCompany) {
        popularityDecrease *= 2.5;
    }
    if (superstar.partTimer) {
        popularityDecrease /= 2.5;
    }
    if (superstar.popularity - popularityDecrease < 800) {
        popularityDecrease += 25;
    }
    return myround(popularityDecrease, 5);
}

function getMatchContractNotHeldPenalty(reputation) {  // get_match_contract_not_held_penalty
    return myround(reputation ** 2 * 25, 10);
}

async function updateInjured(superstars, doctors, company) {  // update_injured
    const data = {
        available: [],
        rehabbed: [],
        staffSkillIncreases: [],
    };
    const game = await getCompanyGame(company);

    for (const superstar of superstars) {
        if (superstar.injured >= 1) {

            // Get doctor
            let doctor = null;
            const assignedDoctor = getTalentRehabDoctor(superstar, doctors);
            if (assignedDoctor) {
                doctor = assignedDoctor;
            } else if (doctors.length > 0) {
                doctor = getHighestLevelStaffMemberByRole(doctors, 'doctor');
            }

            // Don't update superstar injured at latest show
            if (superstar.injuredAtLatestShow) {
                superstar.injuredAtLatestShow = false;
                continue;
            }

            let monthsRecovered = 1;
            const startingMonths = superstar.injured;

            // Check to add rehab if doctor assigned (don't add for kayfabe injuries)
            let rehabPerformed = false;
            const oldTime = getInjuryReturnTime(superstar, doctor);
            if (superstar.injured >= 3 && superstar.injuryName && assignedDoctor) {

                // Check doctor and facility level
                const medicalFacility = (await getCompanyFacilities(company)).find(x => x.name === 'Medical');
                if (doctor && doctor.level >= 2 && medicalFacility && medicalFacility.level >= 2) {
                    const rehabChance = getRehabChance(doctor, medicalFacility);
                    if (getRandomInt(0, 100) <= rehabChance) {
                        rehabPerformed = true;
                        monthsRecovered += 1;

                        // Add doctor xp
                        const ageMultiplier = getStaffAgeMultiplier(doctor);
                        const doctorXpGained = Math.round(5 * ageMultiplier);
                        const doctorLevelIncrease = await updateStaffMemberXp(doctor, doctorXpGained, company, game);
                        if (doctorLevelIncrease) {
                            data['staffSkillIncreases'].push({
                                name: doctor.name,
                                level: doctor.level,
                                role: doctor.role
                            });
                        }

                        data['rehabbed'].push({
                            name: superstar.name,
                            doctorXpGained: doctorXpGained,
                            doctorName: doctor.name,
                            doctorAgeMultiplier: ageMultiplier
                        });
                    }
                }
            }

            // Update injury and return timeline
            superstar.injured -= monthsRecovered;
            if (superstar.injuryReturnMin && superstar.injuryReturnMax) {
                superstar.injuryReturnMin -= monthsRecovered;
                superstar.injuryReturnMax -= monthsRecovered;
            }
            if (superstar.injuryReturnMin <= 0) {
                superstar.injuryReturnMin = 1;
            }
            if (superstar.injuryReturnMax <= 1) {
                superstar.injuryReturnMax = 2;
            }
            const newTime = getInjuryReturnTime(superstar, doctor);

            // Re-evaluate injury when passing month 10 and month 6
            if (superstar.injuryName) {
                if (checkToReevaluateInjury(startingMonths, superstar.injured, doctor)) {
                    const injuryTime = evaluateInjury(superstar, doctor);
                    const injuryData = {
                        name: superstar.name.trim(), time: injuryTime, injuryName: superstar.injuryName, oldTime: oldTime,
                        rehabPerformed: rehabPerformed
                    };
                    if (company.userControlled) {
                        const newMessage = await createInjuryReevaluatedMessage(injuryData, doctor, game.monthCount, game.year);
                        await addCompanyMessages(company, [newMessage]);
                    }
                }
                // Add rehab message if not added with injury reevaluated message
                else if (rehabPerformed) {
                    const injuryData = {
                        name: superstar.name.trim(), rehabPerformed: rehabPerformed, injuryName: superstar.injuryName,
                        oldTime: oldTime, newTime: newTime
                    };
                    if (company.userControlled) {
                        const newMessage = await createInjuryRehabMessage(injuryData, doctor, game.monthCount, game.year);
                        await addCompanyMessages(company, [newMessage]);
                    }
                }
            }

            // Decrease popularity if injury (i.e not kayfabe injury)
            if (superstar.injuryName) {
                if (superstar.popularity < 1000) {
                    superstar.popularity -= 10;
                } else {
                    superstar.popularity -= 5;
                }
            }

            if (superstar.injured === 0) {
                // If not kayfabe or workable injury
                if (superstar.injuryName && !superstar.workableInjury) {
                    const increase = getRandomInt(25, 50);
                    updateSuperstarPopularity(superstar, increase);

                    // Add actions completed (Injuries Recovered)
                    if (globalUser.paid && !['minor injury', 'major injury'].includes(superstar.injuryName)) {
                        await checkFacilityUpgrade('Medical', company);
                    }
                }

                data['available'].push({superstar: superstar, workableInjury: superstar.workableInjury});

                endSuperstarInjury(superstar);
            }
        }
    }

    return data;
}

function checkToReevaluateInjury(startingMonths, endingMonths, doctor) {  // check_to_reevaluate_injury
    // Don't reevaluate if doctor level is 3 or higher, as they give accurate months
    if (doctor && doctor.level >= 3) {
        return false;
    } else if (endingMonths < 10 && startingMonths >= 10) {
        return true;
    } else if (endingMonths < 6 && startingMonths >= 6) {
        return true;
    }
    return false;
}

export {endEvent}